// extracted by mini-css-extract-plugin
export default {"chip":"BaseTag_chip__+Q7SQ","backgroundDefault":"BaseTag_backgroundDefault__4giia","backgroundError":"BaseTag_backgroundError__k+O6Q","outlined":"BaseTag_outlined__eiLwP"};